module.exports = __webpack_public_path__ + "static/media/arles_cryptoporticus.5871aba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/arles_cryptoporticus.png
// module id = 705
// module chunks = 0